import { API_URLS } from '../urls';

import { ReportItem   ,
         ReportList   ,
         ReportStatus } from '../../dataTypes/moderationManagment/report_types';

/**
 * Écran Modération, onglet Signalements (admin-api, ReportModerationController) :
 * réservé aux super-admins. Même plomberie que api_chat.ts — `no-store`, et les
 * erreurs remontent avec le code HTTP : 403 = compte non super-admin, 404 =
 * admin-api pas encore déployé, 503 = migration de customer-api pas passée.
 */
export class ReportModerationError extends Error {
  constructor(message: string, public readonly status: number) {
    super(message);
  }
}

export const fetchReports = async (adminId: number, status: ReportStatus | 'all'): Promise<ReportList> => {
  const res  = await fetch(`${API_URLS.getReports}?adminId=${adminId}&status=${status}`, { cache: 'no-store' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ReportModerationError(data.error ?? `HTTP ${res.status}`, res.status);
  return {
    reports : Array.isArray(data.reports) ? data.reports : [],
    counts  : { open: 0, resolved: 0, dismissed: 0, ...(data.counts ?? {}) },
  };
};

/** `notify` : la décision part par e-mail à chaque auteur (admin-api,
 *  ReportDecisionNotifier). Rend le nombre de signalements modifiés et
 *  d'auteurs prévenus. */
export const decideReports = async (adminId: number, items: Pick<ReportItem, 'kind' | 'id'>[],
                                    status: ReportStatus, note: string,
                                    notify: boolean): Promise<{ done: number; notified: number }> => {
  const res  = await fetch(API_URLS.decideReports, {
    method  : 'POST',
    headers : { 'Content-Type': 'application/json' },
    body    : JSON.stringify({ adminId, items, status, note, notify }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new ReportModerationError(data.error ?? `HTTP ${res.status}`, res.status);
  return { done: data.done ?? 0, notified: data.notified ?? 0 };
};
